'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _themeSections = require('@shopify/theme-sections');

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _slickCarousel = require('slick-carousel');

var _slickCarousel2 = _interopRequireDefault(_slickCarousel);

var _slick = require('../modules/slick');

var _slick2 = _interopRequireDefault(_slick);

require('../../styles/sections/index-hero.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _themeSections.register)('index-hero', {
  onLoad: function onLoad() {
    var container = this.container;
    this.slideshow = (0, _jquery2.default)(container).find('.hero-wrapper');

    this.settings = (0, _slick2.default)({
      appendArrows: (0, _jquery2.default)(this.slideshow).siblings('.slick-arrows'),
      arrows: true,
      adaptiveHeight: true
    });

    this.slideshow.slick(this.settings);

    this.slideshow.on('setPosition', function (event, slick) {
      var trigger = new Event('slick:resize');
      document.dispatchEvent(trigger);
    });

    var trigger = new Event('lazy:reload');
    document.dispatchEvent(trigger);
  },
  onUnload: function onUnload() {},
  onBlockSelect: function onBlockSelect(block, load) {
    var index = this.slideshow.find('[data-id="' + block + '"]').data('slick-index');
    this.slideshow.slick('goTo', index);
  }
});